import { FiltersV2EventHandlers, FilterV2Event, useFiltersV2EventsBus } from "PFApp/components/filters_v2";
import { useEffect } from "react";

export const useOnFiltersMetaSync = (action: FiltersV2EventHandlers[FilterV2Event.FiltersMetaSynced]) => {
  const eventsBus = useFiltersV2EventsBus();

  useEffect(() => {
    eventsBus.on(FilterV2Event.FiltersMetaSynced, action);

    return () => {
      eventsBus.removeListener(FilterV2Event.FiltersMetaSynced, action);
    };
  }, [eventsBus, action]);
};
